import React from 'react';
import PropTypes from 'prop-types';
import ReactEchartsCore from 'echarts-for-react/lib/core';
import echarts from 'echarts/lib/echarts';
import 'echarts/lib/component/title';

import 'echarts/lib/chart/bar';

import NHFetch from '../../utils/NHFetch.js';

const yxxtBasicUrl = 'api/zhxg-yxxt'; //迎新管理服务后台接口基础路径
const errMaxCount = 3; // 请求异常最大次数
const speed = 60 * 1000; //轮询时间间隔

/**
 * * 专业招生数量排名条形统计图
 * Author: zengxiangkai@ly-sky.com
 * Created on: 2018-07-04 
 * Version: 1.0
 * Modify log:
 */
class IndexComponent extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            errCount: 0, //连续请求错误次数
            barData: [], //各专业新生人数
        }

        this.polling; //轮询定时器
    }

    componentDidMount() {
        this.getData();
    }

    componentWillUnmount() {
        //组件卸载时清除轮询定时器
        if (this.polling) {
            clearTimeout(this.polling);
        }
    }

    /**
     * * 环节专业新生人数数据
     * @memberof IndexComponent
     */
    getData = () => {
        NHFetch(yxxtBasicUrl + '/sstj/getStudentTotalNumberForMajor', 'GET')
            .then(res => {
                if (res && res.data) {
                    //由于专业新生人数是一开始就确定的，所以这里只有当出现异常的时候才进行轮询尝试
                    this.setState({ errCount: 0, barData: res.data });
                }
            }).catch(err => {
                let errCount = this.state.errCount;
                //如果请求异常次数未超过最大次数限制，则继续尝试
                if (errCount < errMaxCount) {
                    this.polling = setTimeout(() => {
                        this.getData();
                    }, speed);
                    this.setState({ errCount: errCount + 1 });
                } else {
                    //异常超过3次后终止轮询
                    if (this.polling) {
                        clearTimeout(this.polling);
                    }
                }
            });
    }

    /**
     * * 构造条形统计图
     * @memberof Home
     */
    getBarOption = () => {

        const { barData = [] } = this.state;
        const { rem } = this.props;

        // y轴标题
        let yAxisTitles = barData.map(item => {
            return item.zymc ? item.zymc : '';
        });

        // y轴值
        let maxzyrs = 0;
        let yAxisData = barData.map(item => {
            if (item.zyrs > maxzyrs) maxzyrs = item.zyrs
            return item.zyrs ? item.zyrs : 0;
        });
        let dataRes = new Array(barData.length)
        dataRes.fill(maxzyrs)
        const option = {
            title: {
                text: '专业招生数量Top10',
                textStyle: {
                    color: '#05ffe3',
                    fontSize: 0.18 * rem
                }
            },
            grid: {
                left: '-37%',
                right: '2%',
                top: '8%',
                bottom: 0,
                containLabel: true
            },
            xAxis: {
                show: false
            },
            yAxis: [
                {
                    show: true,
                    data: yAxisTitles,
                    inverse: true,
                    axisLine: {
                        show: false
                    },
                    splitLine: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        formatter: (value, index) => {

                            //专业名字过长时，超过9个字则换行
                                let maxLenth = 9;
                                let titleStr = [];
                            if (value.length > 0) {
                                let count = parseInt(value.length / maxLenth) + 1;
                                for (let i = 0; i < count; i++) {
                                    if (i == 0) {

                                        titleStr.push(`{lg|${index + 1}}  ` + '{title|' + value.substr(0, maxLenth).padEnd(maxLenth, '') + '} ');

                                    } else {

                                        titleStr.push('{title|' + value.substr(i * maxLenth ,maxLenth) + '} ');

                                    }
                                }
                            }

                            return titleStr.length > 1 ? titleStr.join('\n') : titleStr.join("");
                        },
                        margin: 140,
                        textStyle: {
                            fontSize: 0.14 * rem,
                            align: 'left'
                        },
                        rich: {
                            lg: {
                                backgroundColor: '#74dafc',
                                color: '#18306F',
                                borderRadius: 0.18 * rem,
                                align: 'center',
                                width: 0.18 * rem,
                                height: 0.18 * rem
                            },
                            title: {
                                color: '#00ffca',
                            }
                        }
                    }
                },
                {
                    show: true,
                    inverse: true,
                    data: yAxisData,
                    axisLabel: {
                        textStyle: {
                            fontSize: 0.14 * rem,
                            color: '#fce412'
                        }
                    },
                    axisLine: {
                        show: false
                    },
                    splitLine: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    }
                }
            ],
            series: [
                {
                    type: 'bar',
                    barWidth: '33%',
                    barHeight: '100%',
                    itemStyle: {
                        normal: {
                            borderColor: '#d0e932',
                            borderWidth: 1,
                            barBorderRadius: 0.2 * rem,
                            color: 'rgba(29, 50, 143,0)'
                        },
                    },
                    z: 99,
                    data: dataRes,
                },
                {
                    name: '条',
                    type: 'bar',
                    barGap: '-91%',
                    barWidth: '27%',
                    barHeight: '100%',
                    barMaxWidth: 0.14 * rem,
                    barMinHeight: 6,
                    yAxisIndex: 0,
                    data: yAxisData,
                    silent: false,
                    barCategoryGap: '60%',
                    itemStyle: {
                        normal: {
                            barBorderRadius: 0.2 * rem,
                            color: {
                                type: 'bar',
                                colorStops: [
                                    {
                                        offset: 0,
                                        color: '#00ffca' // 0% 处的颜色
                                    },
                                    {
                                        offset: 1,
                                        color: '#fce412' // 100% 处的颜色
                                    }
                                ],
                                globalCoord: false // 缺省为 false
                            }
                        }
                    }
                }
            ]
        };
        return option;
    };

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <ReactEchartsCore
                    style={{ width: '100%', height: '100%' }}
                    echarts={echarts}
                    option={this.getBarOption()}
                    notMerge={true}
                    lazyUpdate={true}
                />
            </div>
        )
    }

}

IndexComponent.defaultProps = {
}

IndexComponent.propTypes = {
    rem: PropTypes.number,
}

export default IndexComponent;


// WEBPACK FOOTER //
// ./containers/Show-sszy/_BarBox2.js